import type {
  Exporter,
  ExporterBrief,
  ExportersStorage,
} from '../model/exporter';

import { Page, PaginationParams } from '@/shared/api/pagination';
import type { AxiosRequestConfig } from 'axios';

import { monitoringInstance } from '@/shared/api/api-instances/monitoring/api-instance';
import { ImportEntities } from '@/shared/api/import-contracts';

const baseURL = '/api/monitoring/v4/';
const defaultOptions = { baseURL };
export class ExportersAPI {
  static getExporters(params: PaginationParams, options?: AxiosRequestConfig) {
    return monitoringInstance.get<Page<ExporterBrief>>('/exporters', {
      ...options,
      params,
    });
  }

  static getExportersStorage(options?: AxiosRequestConfig) {
    return monitoringInstance.get<ExportersStorage[]>(
      '/exporters/config/storage',
      options,
    );
  }

  static updateExporter(
    name: string,
    payload: Exporter,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.patch(`/exporter/${name}`, payload, options);
  }

  static applyExporter(
    params: { exporter_name: string },
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.post<void>(
      `/exporter/${params.exporter_name}/apply`,
      options,
    );
  }

  static getExporterByName(payload: string, options?: AxiosRequestConfig) {
    return monitoringInstance.get<Exporter>(`/exporter/${payload}`, options);
  }

  static createExporter(payload: Exporter, options?: AxiosRequestConfig) {
    return monitoringInstance.post(
      `/exporter/${payload.control_mode}`,
      payload,
      options,
    );
  }

  static deleteExporter(name: string, options?: AxiosRequestConfig) {
    return monitoringInstance.delete(`/exporter/${name}`, options);
  }

  static exportExportersV4(
    exporter_names: string[],
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.get<{
      exporters: Exporter[];
    }>('/exporter/export/json', {
      ...defaultOptions,
      ...options,
      params: { exporter_names },
      paramsSerializer: () => {
        const searchParams = new URLSearchParams();
        exporter_names.forEach((name) =>
          searchParams.append('exporter_names', name),
        );
        return searchParams.toString();
      },
    });
  }

  static analyzeExporterEntities(json: string, options?: AxiosRequestConfig) {
    return monitoringInstance.post('/import/exporter/analyze', json, {
      ...defaultOptions,
      ...options,
    });
  }

  static executeExporterEntities(
    data: ImportEntities,
    options?: AxiosRequestConfig,
  ) {
    return monitoringInstance.post('/import/exporter/execute', data, {
      ...defaultOptions,
      ...options,
    });
  }

  static validateImport(json: any, options?: AxiosRequestConfig) {
    return monitoringInstance.post('/import/exporter/validate', json, {
      ...defaultOptions,
      ...options,
    });
  }
}